import React, { useState } from 'react';
import { View, Text, ActivityIndicator } from 'react-native';
import { connect } from 'react-redux';
import i18n from 'i18n-js';

import ColorWrapper from '@styles/colors';
import { font } from '@styles/fonts';

import { scale } from '@components/frame';
import { isPhone } from '@helpers';
import TouchableElement from '@components/common/touchableElement';
import EditableLine from '@components/common/editableLine';

import { configureGroup } from '@reducers/machines';
import { modalFieldBg } from '@v2/pages/common/constants/base.constants';

const Create = ({ C, updateData, data = {}, isSaveActive, inputs, isLoading, submit, hide }) => {
  return (
    <View style={[{ width: '100%', paddingBottom: scale(18) }]}>
      <View
        style={{
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
          zIndex: 1000,
          height: scale(72),
        }}
      >
        <View>
          <TouchableElement onPress={hide}>
            {({ boxStyle, pressHoverColor }) => (
              <View style={[boxStyle, { padding: scale(15) }]}>
                <Text style={[{ color: C(pressHoverColor('System/Light/Blue')) }, font.Body]}>{i18n.t('Cancel')}</Text>
              </View>
            )}
          </TouchableElement>
        </View>
        <View>
          <TouchableElement onPress={submit}>
            {({ boxStyle, pressHoverColor }) => (
              <View style={[boxStyle, { padding: scale(15) }]}>
                {isLoading ? (
                  <ActivityIndicator size="small" color="#777777" />
                ) : (
                  <Text style={[{ color: C(pressHoverColor(isSaveActive ? 'Link/Light/Primary' : 'Label/Light/Quinary')) }, font.Body]}>
                    {i18n.t('Done')}
                  </Text>
                )}
              </View>
            )}
          </TouchableElement>
        </View>
      </View>
      <View style={{ width: '100%', position: 'absolute', zIndex: 100, top: scale(15) }}>
        <Text style={[{ color: C('Label/Light/Primary'), width: '100%', textAlign: 'center' }, font.Headline]}>
          {i18n.t('New Machine Group Name')}
        </Text>
      </View>
      <View style={{ width: '100%', paddingLeft: scale(15), paddingRight: scale(15) }}>
        {inputs.map((item, index) => (
          <EditableLine
            key={item.key}
            {...{
              item: {
                value: data[item.key],
                onChange: (v) => updateData(item.key, v),
                ...item,
              },
              bg: modalFieldBg,
              index,
              array: inputs,
              C,
              bottomBorderBox: false,
              topBorder: index !== 0,
              roundTop: index === 0,
              roundBottom: index === inputs.length - 1,
            }}
          />
        ))}
      </View>
    </View>
  );
};

const ConfigureGroup = (props) => {
  const { configureGroup, hide } = props;

  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState({});

  const isSaveActive = Boolean(data.name);

  const submit = async () => {
    if (!isSaveActive || isLoading) {
      return;
    }
    setLoading(true);
    await configureGroup(
      {
        name: data.name,
        action: 'store',
      },
      () => {
        hide();
        setTimeout(() => {
          setData({});
        }, 1000);
      }
    );
    setLoading(false);
  };

  const inputs = [
    {
      key: 'name',
      placeholder: 'Name',
      noArrow: true,
      isLable: false,
    },
  ];

  const updateData = (key, v) => {
    const newData = {
      ...data,
      [key]: v,
    };
    setData(newData);
  };

  const itemProps = {
    ...props,
    updateData,
    data,
    isSaveActive,
    inputs,
    isLoading,
    submit,
    hide,
  };

  return <Create {...itemProps} />;
};
export default connect(null, { configureGroup })(ColorWrapper(ConfigureGroup));
